import API from 'utils/api';
import { onSuccess, onError } from 'utils/handlers';

export const baseURI = 'usuarios/administradores-de-la-entidad';

/**
 * GET Usuarios Administradores
 * @returns {Promise<object[]>}
 */
export const getUsuariosAdministradores = async () => {
  try {
    const response = await API.get(baseURI);
    return response.data;
  } catch (err) {
    onError(err);
    return [];
  }
};

/**
 * POST Usuario Administrador
 * @param {object} values
 * @returns {Promise<object|boolean>}
 */
export const postUsuarioAdministrador = async (values) => {
  try {
    const response = await API.post(baseURI, values);
    onSuccess(response, 'Agregado correctamente');
    return response.data;
  } catch (err) {
    onError(err);
    return false;
  }
};

/**
 * DELETE Usuario Administrador
 * @param {number} id
 * @returns {Promise<boolean>}
 */
export const deleteUsuarioAdministrador = async (id) => {
  try {
    const response = await API.delete(`${baseURI}/${id}`);
    onSuccess(response, 'Eliminado correctamente');
    return true;
  } catch (err) {
    onError(err);
    return false;
  }
};
